@if (sizes) {
    <div class="info-container">
        @if (amountOfSizes === 1) {
            <p class="delete-sizes">You are deleting the size:</p>
        } @else {
            <p class="delete-sizes">You are deleting {{ amountOfSizes }} sizes:</p>
        }
        <div class="size-container">
            <ul class="size-list">
                @for (size of displaySizeArr; track size.id) {
                    <li class="list-item">
                        <p>{{ size.width }} &times; {{ size.height }}</p>
                    </li>
                }
            </ul>
            @if (amountOfSizes > 3) {
                <p
                    class="tooltip-text"
                    uiTooltip="{{ tooltipSizes }}"
                    uiTooltipTrigger="hover"
                    uiTooltipPosition="right">
                    +{{ amountOfSizes - displaySizeArr.length }} more
                </p>
            }
        </div>
        <p class="warning-text">Elements not used in other active sizes will be lost.</p>
        <p class="warning-text second-row">
            This action affects <strong>all versions</strong> and can not be undone.
        </p>
    </div>
    <ui-dialog-buttons ui-theme="default">
        <ui-button
            text="Cancel"
            (click)="cancel()">
        </ui-button>
        <ui-button
            type="primary"
            text="{{ deleteButtontext }}"
            (click)="deleteSizes()">
        </ui-button>
    </ui-dialog-buttons>
}
